import React from "react";
import { computePercentage, convertMinutesToString } from "../utils/date.utils";

export const TextDuration = ({ label, duration, durationTotal }) => {
  return (
    <div className="flex">
      <span className="my-2 text-lg text-gray-700">{label} : </span>
      <span className="my-2 mx-2 text-lg text-gray-700 font-bold">{`${computePercentage(
        duration,
        durationTotal
      )} (${convertMinutesToString(duration)})`}</span>
    </div>
  );
};

export const TextLabelData = ({ data, label }) => {
  return (
    <div className="flex">
      <span className="my-2 text-lg text-gray-700">{label} : </span>
      <span className="my-2 mx-2 text-lg text-gray-700 font-bold">{data}</span>
    </div>
  );
};



// WEBPACK FOOTER //
// src/modules/presence/components/TextDuration.js